export enum EInvoiceStatusTypes {
	Deleted = "DELETED",
}

export default EInvoiceStatusTypes;